export default "__VITE_ASSET__BmPcK9ra__"